var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"banner"}},[_c('v-row',{staticClass:"mx-0",attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('serviceworker',{attrs:{"id":"serviceworker"}})],1),_c('v-row',{staticClass:"mx-0",attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('warning')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }